<template>
  <div class="select-type">
    <div class="h1-title">请选择感兴趣的作品类型</div>
    <transition enter-active-class="animated fadeInRight">
      <ul class="select-list clearfix" v-if="showList">
        <li  @click="checkTag(index,item)" v-for="(item, index) in selected" :key="index" :class="item.selected">
          <img class="bg-img" :src="item.cover" alt="">
          <div class="mask">
            <i class="icon"></i>
            <span class="l-tit">{{item.tag}}</span>
          </div>
        </li>
      </ul>
    </transition>
    <div class="check-all">
      <el-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
    </div>
    <div class="queding">
      <el-button class="btn" size="medium" @click="getTags">换一批</el-button>
      <el-button class="btn" size="medium" @click="wancheng">完 成</el-button>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  //import "../../../static/css/animate.min.css"
  import vue from 'vue';
  import qs from 'qs';
  import global_ from '@/api/global'
  import tagApi from '@/api/tags'
  vue.prototype.qs = qs;
  import updateTdk from "@/utils/tdk";
  import VueCookies from 'vue-cookies'
  vue.use(VueCookies);
export default {
  components: {

  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
    };
  },
  data () {
    return {
        headTitle: "选择类型-人人动画网【官网】",
        headKeywords: "选择类型-人人动画网【官网】",
        headDesc: "选择类型-人人动画网【官网】",
        isMounted: false ,//for control not ssr render
      page:1,
      total:0,
      tagParam:{
        type:0,
        parentId:-1,
      },
      checkAll: false,
      active:"",
      selected:[

      ],
      showList: true
    }
  },
  created() {
    this.checkIsLogin();
  },
  serverPrefetch() {
    updateTdk.call(this);
  },
  mounted() {
    console.log("_this.$cookies",this.$cookies.get("formUrl"))
    this.isMounted = true;
    this.getTags(1);
    let url=window.location.href.substring(window.location.href.indexOf("callback"),window.location.href.length).replace("callback=","");
    this.callback=decodeURIComponent(url)
    console.log("callbacksetname",this.callback)
  },
  methods:{

    checkIsLogin: function () {
      let _this = this;
      let url = '/api/checkLogin?time=' + new Date().getMilliseconds();
      this.$axios.get(url).then(function (result) {
        if (result.data.isLogin && result.data.casFastUserModel != null) {
          global_.setUserModel(result.data.casFastUserModel);
          global_.setIsLogin(true)
        } else {
          let callBack=window.location.href;
          _this.$router.push("/login?callback="+callBack)
        }
      })
    },
    getTags(){
      let this_ = this;
      this_.showList = false
      let url = '/rrbi/tags/getPageList?page='+this.page+'&time=' + new Date().getMilliseconds();
      this_.$axios.post(url,this_.tagParam).then(function (result) {
        console.log(result.data.response.total)
        this_.total=result.data.response.total;
        this_.selected=result.data.response.list
        this_.showList = true
        this_.selected.forEach (function (selTag,index) {
          console.log(index,selTag)
          if(selTag.active){
            this_.selected[index].selected="active"
          }

        });
        if(this_.page*6>=this_.total){
          this_.page=1
        }else{
          this_.page=this_.page+1;
        }
        let isCheckAll=1;
        this_.selected.forEach((item,index)=>{
          if(item.selected==""){
            isCheckAll=0;
          }
        })
        if(isCheckAll==1){
          this_.checkAll=true;
        }else{
          this_.checkAll=false;
        }
      })
    },
    checkTag(index,item){
      console.log(index)
      console.log(item)
      let ids=[];
      ids.push(item.id)
      let isCheckAll=1;
      if(this.selected[index].selected!=""){

        this.selected[index].selected="";
        this.selected.forEach((item,index)=>{
          if(item.selected==""){
            isCheckAll=0;
          }
        })
        this.removeUserTags(ids.toString())
      }else{
        this.selected[index].selected="active"
        this.selected.forEach((item,index)=>{
          if(item.selected==""){
            isCheckAll=0;
          }
        })
        this.addUserTags(ids.toString())
      }
      if(isCheckAll==1){
        this.checkAll=true;
      }else{
        this.checkAll=false;
      }
    },
    handleCheckAllChange(){
      console.log(this.checkAll)
      let ids=[];

      if(this.checkAll){
        this.checkAll=true;
        this.selected.forEach((item,index)=>{
          this.selected[index].selected="active";
          ids.push(item.id)
        })
        this.addUserTags(ids.toString())
      }else{
        this.checkAll=false;
        this.selected.forEach((item,index)=>{
          this.selected[index].selected="";
          ids.push(item.id)
        })
        this.removeUserTags(ids.toString())
      }
    },
    removeUserTags(ids){
      let _this=this;
      let url="/rrbi/interests/removeUserInterest"

      console.log(ids)
      let postData={
        ids: ids
      }

      _this.$axios.post(url, qs.stringify(postData)).then(function(result){

        if(result.data.code==1){
          _this.$message({
            message: '取消成功',
            type: 'success'
          });
        }
      })
    },
    addUserTags(ids){
      let _this=this;
      let url="/rrbi/interests/addUserTags"

      let postData={
        ids: ids.toString()
      }

      _this.$axios.post(url, qs.stringify(postData)).then(function(result){

        if(result.data.code==1){
          _this.$message({
            message: '选择成功',
            type: 'success'
          });
        }
      })
    },
    wancheng(){
      let _this=this;
      let url="/rrbi/tags/getUserTags?tem="+new Date().getTime();
      this.$axios.get(url).then(function (result) {
       console.log(result.data.response.length)
        if(result.data.response.length>0){
          if(_this.$cookies.get("formUrl")!=null&&_this.$cookies.get("formUrl")!=undefined&&_this.$cookies.get("formUrl")!=""){
            window.location.href =_this.$cookies.get("formUrl")
          }else{
            if(_this.callback!="http://www.renrendonghua.com/selecttype"){
              window.location.href =_this.callback
            }else{
              window.location.href ="http://www.renrendonghua.com"
            }
          }

          console.log(_this.callback)
          // window.location.href =_this.callback
        }else {
          _this.$message({
            message: '请至少选择一个喜欢的类型',
            type: 'error'
          });
        }
        // window.location.href =_this.callback
      })

    },
  },
}
</script>

<style scoped lang="less">
.select-type{
  margin: 0 auto;
  padding-top: @NAVHEIGHT;
  .h1-title{
    text-align: center;
    color: #434343;
    font-size: 20px;
    font-weight: bold;
  }
  .select-list{
    li{
      overflow: hidden;
      float: left;
      position: relative;
      border-radius: 5px;
      cursor: pointer;
      .bg-img{
        width: 100%;
      }
      .mask{
        position: absolute;
        left: 0;top: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.2);
        .icon{
          display: block;
          width: 40px;
          height: 40px;
          background-image: url('../../assets/images/inter_icon.png');
          background-size: 100% 100%;
        }
        .l-tit{
          margin-top: 10px;
          color: #fff;
          font-size: 20px;
          font-weight: bold;
        }
      }
      &.active{
        .mask{
          background: rgba(255,0,0,.4);
          .icon{
            background-image: url('../../assets/images/inter_icon_active.png')
          }
        }
      }
    }
  }
  .check-all{
    padding: 0 10px;
    margin: 10px 0;
  }
  .queding{
    margin: 40px 0;
    text-align: center;
    .btn{
      width: 104px;
      font-size: 16px;
    }
  }
}
@media screen and (max-width: 750px) {
  .select-type{
    width: 100%;
    .h1-title{
      margin: 20px 0;
    }
    .select-list{
      li{
        margin-left: 3.333%;
        margin-bottom: 10px;
        padding-bottom: 29.07%;
        width: 45%;
        height: 0;
        .mask{
          .l-tit{
            font-size: 16px;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 751px) {
  .select-type{
    width: 700px;
    .h1-title{
      margin: 30px 0;
    }
    .select-list{
      li{
        margin-left: 33.33px;
        margin-bottom: 33.33px;
        width: 300px;
        height: 194px;
      }
    }
  }
}
@media screen and (min-width: 1024px) {
  .select-type{
    width: 1000px;
    .h1-title{
      margin: 50px 0;
    }
    .select-list{
      li{
        margin-left: 10px;
        margin-bottom: 10px;
        width: 320px;
        height: 207px;
      }
    }
  }
}
@media screen and (min-width: 1250px) {

}
</style>
